import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import * as categoryRedux from "../_redux/categoryRedux";
import Box from "@material-ui/core/Box";
import { Hidden } from "@material-ui/core";
import { generateCategoryDetail } from "helpers";
import { getCategoryVisual } from "helpers/categoryVisual";
import { FaTags, FaShieldAlt, FaUsers } from "react-icons/fa";

const CategoryList = () => {
  const { categories } = useSelector(
    (state) => ({
      categories: state.category.categories,
    }),
    shallowEqual
  );
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid spacing={3}>
        <Grid item sx={12}>
          <Paper className={classes.categoryHeader}>Kategoriler </Paper>
        </Grid>
        <Grid className={classes.categoryListContainer}>
          {categories.map((category) => {
            const { Icon, color, image } = getCategoryVisual(category);
            return (
            <div key={category._id}>
              <Link to={generateCategoryDetail(category.slug)}>
                <Grid item xs={12}>
                  <Paper
                    className={classes.categoryItemsContainer}
                    style={{ boxShadow: "none" }}
                  >
                    <Box
                      className={classes.categoryBox}
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                    >
                      {image ? (
                        <Grid
                          className={classes.categoryItems}
                          style={{
                            padding: 0,
                            borderRadius: "50%",
                            overflow: "hidden",
                            width: 50,
                            height: 50,
                            boxShadow: `0 8px 16px -6px ${color}`,
                          }}
                        >
                          <img
                            src={image}
                            alt={category.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                        </Grid>
                      ) : (
                        <Grid
                          className={classes.categoryItems}
                          style={{
                            background: color,
                            backgroundImage:
                              "linear-gradient(145deg, rgba(255,255,255,0.32), rgba(255,255,255,0) 62%)",
                            borderRadius: "16px",
                            boxShadow: `0 8px 16px -6px ${color}`,
                          }}
                        >
                          <Icon size={34} color="#fff" />
                        </Grid>
                      )}
                      <Box
                        className={classes.categoryItemsContent}
                        p={1}
                        textOverflow="ellipsis"
                      >
                        {category.name}
                      </Box>
                    </Box>
                    {category.rate ? (
                      <Hidden smDown={true}>
                        <span
                          style={{
                            background: color,
                            color: "#fff",
                            fontWeight: 800,
                            fontSize: "12px",
                            padding: "3px 11px",
                            borderRadius: "999px",
                            boxShadow: `0 4px 10px -4px ${color}`,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {category.rate}
                        </span>
                      </Hidden>
                    ) : null}
                  </Paper>
                </Grid>
              </Link>
            </div>
            );
          })}
        </Grid>
        <Hidden smDown>
          <Link to="/ilan-ver" className={classes.promo}>
            <span className={classes.promoTagline}>
              Türkiye'nin <strong>tek ücretsiz</strong> ilan sitesi
            </span>
            <span className={classes.promoBrand}>
              Alıcılar<span className={classes.promoBrandDot}>.com</span>
            </span>
            <span className={classes.promoFeatures}>
              <span className={classes.promoFeature}>
                <FaTags className={classes.promoFeatureIco} />
                %100 Ücretsiz
              </span>
              <span className={classes.promoFeature}>
                <FaShieldAlt className={classes.promoFeatureIco} />
                Güvenli Alışveriş
              </span>
              <span className={classes.promoFeature}>
                <FaUsers className={classes.promoFeatureIco} />
                Geniş Kitle
              </span>
            </span>
            <span className={classes.promoCta}>Hemen İlan Ver</span>
          </Link>
        </Hidden>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: "0 0 20px 0 rgb(0 0 0 / 20%)",
    borderRadius: "8px",
    background: "#fff",
  },
  categoryHeader: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: "black",
    fontWeight: "600",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    fontSize: "1.1rem",
    letterSpacing: "0.5px",
  },
  categoryItemsContainer: {
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),

    textAlign: "left",
    color: theme.palette.text.secondary,
    borderRadius: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  categoryItems: {
    borderRadius: "50%",
    padding: "8px",
    display: "flex",
    alignItems: "center",
  },
  categoryListContainer: {
    maxHeight: "390px",
    overflowY: "auto",
    padding: "0 5px 0 0",
    background: "#fff",
    // borderRadius: "8px",
    [theme.breakpoints.between("xs", "sm")]: {
      display: "flex",
      overflowX: "scroll",
      maxHeight: "none",
    },
    [theme.breakpoints.between("md", "lg")]: {
      maxHeight: "340px",
    },
  },
  categoryItemsContent: {
    fontWeight: "400",
    color: "#555555",
    fontSize: "1.1rem",
    [theme.breakpoints.between("xs", "sm")]: {
      fontSize: "14px",
      whiteSpace: "nowrap",
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: "14px",
    },
  },
  categoryBox: {
    [theme.breakpoints.between("xs", "sm")]: {
      flexDirection: "column",
    },
  },
  icon: {
    color: "#fff",
  },
  promo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    flexShrink: 0,
    margin: "14px 10px 14px",
    padding: "18px 14px 16px",
    borderRadius: "14px",
    background: "linear-gradient(160deg, #ffffff 0%, #f3f8f6 100%)",
    border: "1px solid #e8efeb",
    boxShadow: "0 8px 22px -12px rgba(15,27,23,0.22)",
    textDecoration: "none",
    transition: "transform 0.18s ease, box-shadow 0.18s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 14px 28px -12px rgba(15,27,23,0.28)",
    },
  },
  promoTagline: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#1d2b27",
    lineHeight: 1.35,
    "& strong": { color: "#f08a3e", fontWeight: 800 },
  },
  promoBrand: {
    marginTop: "4px",
    fontSize: "26px",
    fontWeight: 900,
    letterSpacing: "-0.5px",
    color: "#1b3a5b",
    lineHeight: 1,
  },
  promoBrandDot: {
    color: "#f08a3e",
  },
  promoFeatures: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "6px 10px",
    margin: "12px 0 14px",
  },
  promoFeature: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "11px",
    fontWeight: 600,
    color: "#5d6d68",
  },
  promoFeatureIco: {
    color: "#16A571",
    fontSize: "13px",
  },
  promoCta: {
    display: "block",
    width: "100%",
    padding: "10px 12px",
    borderRadius: "999px",
    background: "linear-gradient(135deg, #f08a3e 0%, #ec6b2d 100%)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: 800,
    letterSpacing: "0.3px",
    boxShadow: "0 8px 16px -8px rgba(236,107,45,0.7)",
  },
}));

export default connect(null, {
  ...advertRedux.actions,
  ...categoryRedux.actions,
})(CategoryList);
